import { render, staticRenderFns } from "./transferin_invunit.vue?vue&type=template&id=1d42be9f"
import script from "./transferin_invunit.vue?vue&type=script&lang=js"
export * from "./transferin_invunit.vue?vue&type=script&lang=js"
import style0 from "./transferin_invunit.vue?vue&type=style&index=0&id=1d42be9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports